export const getApiHost = () => {
  if (window.location.hostname.indexOf("localhost") !== -1) {
    return "http://localhost:4000";
  } else {
    return "https://api.curso.run";
  }
};
